import { vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["id", "disabled", "placeholder", "rows"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "is-auto-fill": _ctx.isAutoFill,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _withDirectives(_createElementVNode("textarea", _mergeProps({
                class: ['form-control h-100', _ctx.isInvalid ? 'is-invalid' : ''],
                id: identification,
                disabled: disabled,
                placeholder: _ctx.placeholder,
                rows: _ctx.rows
            }, _ctx.inputAttrInternal, {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event)),
                onBlur: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
                onKeyup: _cache[2] || (_cache[2] =
                    //@ts-ignore
                    (...args) => (_ctx.onEnterKey && _ctx.onEnterKey(...args)))
            }), null, 16, _hoisted_1), [
                [_vModelText, _ctx.internalValue]
            ])
        ]),
        _: 1
    }, 16, ["name", "is-auto-fill", "error-message", "label"]));
}
